import StandardGateway from './lib/standard_gateway';

export default class SearchHttpGateway extends StandardGateway {
  constructor(backend) {
    super(backend, { fetchUrl: '/api/v1/orgs/:orgId/search' });
  }

  fetch(id, params) {
    let url = this.endpoint.set(params).fetchUrl;
    return this.http.post(url, params);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/search_http_gateway.js